/* hx-bundle-options.js — the bundle PDP's per-component choices.

   Simple Bundles owns the choice on a bundle: it names the options, and it
   reads properties[_bundle_selection] back when the order lands. So the theme
   does not build its own dropdown here; it takes the app's and dresses it.

   The section renders an empty [data-simple-bundles-options] inside the buy
   box, which is the app's placement hook. On every load the app fills it with a
   <label> and a native <select> per option. This file then, for each select:
   restyles it as the site's flavour dropdown, and moves the pair into the
   component row it belongs to, matched on the words of the component's name.

   The select itself never leaves the form and is still the only thing
   submitted, so what the app receives is byte for byte what it would have
   received from its own markup. If this file never runs, the app's plain
   selects are still there and still work.

   The app re-injects on a timer and whenever the variant input changes, which
   wipes the container each time — hence the observer, and hence the guard that
   ignores selects already dressed. */
(function(){
  var box = document.querySelector('[data-simple-bundles-options]');
  if (!box || !window.HxFlavourSelect) return;
  var rows = document.querySelector('[data-bundle-rows]');

  /* "of", "the" and "and" sit in half the product names, so they say nothing
     about which row an option belongs to. */
  var SKIP = {of: 1, the: 1, and: 1, a: 1, s: 1};
  function words(text){
    return String(text || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim()
      .split(' ').filter(function(w){ return w && !SKIP[w]; });
  }

  /* The app names an option after the whole product: "Protein of the Gods –
     Premium Smooth Plant Protein - Flavour (Dropdown 1)". Inside a row the row
     already names the product, so all that is wanted is the last part. */
  function fieldLabel(name){
    var t = String(name || '').replace(/\s*\((?:dropdown|select)[^)]*\)\s*$/i, '').trim();
    var parts = t.split(/\s+-\s+/);
    t = (parts[parts.length - 1] || t).trim();
    if (/^colou?r$/i.test(t)) t = 'Colour';
    return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
  }

  /* The component JSON and the app's option names are written by different
     people, so they never match exactly. A row claims an option only when every
     word of its name turns up in that option — strict enough that nothing lands
     in the wrong row.

     "In that option" means the option's name AND the text of its choices,
     because the app puts the product in one or the other depending on how the
     component was set up. "Hercules Shaker" is in the name of "Hercules
     Signature Shaker Bottle Box - Color", but "Protein of the Gods" is nowhere
     in an option merely named "Protein (select 1)" — it is in every one of its
     choices, "Protein of the Gods – Premium Smooth Plant Protein - Vulcan
     Vanilla" and the rest. Reading the name alone left that row claiming there
     was no flavour to pick while its dropdown sat below the bundle.

     Anything unclaimed stays in the container, labelled in full, rather than
     going missing. */
  function rowFor(native, optionName){
    if (!rows) return null;
    var hay = words(optionName);
    for (var o = 0; o < native.options.length; o++){
      if (native.options[o].value === '') continue;
      hay = hay.concat(words(native.options[o].textContent));
    }
    var best = null, items = rows.querySelectorAll('.item');
    for (var i = 0; i < items.length; i++){
      var need = words(items[i].dataset.componentName);
      if (!need.length) continue;
      var all = need.every(function(w){ return hay.indexOf(w) > -1; });
      if (all && (!best || need.length > best.need)) best = {row: items[i], need: need.length};
    }
    return best ? best.row : null;
  }

  /* One choice is not a choice, and its label is the whole product: "100%
     Creatine Monohydrate - Memory & Performance Supplement - 300g". The row
     already names the product, so cut back to the last separator whose lead-in
     covers every word of the row's name and keep what is left — "300g". With no
     such separator the text stands as it is; nothing is guessed away. */
  function trimToRow(text, rowName){
    var need = words(rowName);
    if (!need.length) return text;
    var cut = -1, sep = /\s+[-\u2013]\s+|:\s+/g, m;
    while ((m = sep.exec(text)) !== null){
      var lead = words(text.slice(0, m.index));
      if (need.every(function(w){ return lead.indexOf(w) > -1; })) cut = m.index + m[0].length;
    }
    return cut > -1 ? (text.slice(cut).trim() || text) : text;
  }

  /* Everything these choices have in common is the product they belong to, and
     the row above already names it. Cut it off, but only at a separator, so
     "Gaia's Green Apple" and "Gaia's Passion Melon" keep their Gaia. */
  function sharedPrefix(native){
    var texts = [];
    for (var i = 0; i < native.options.length; i++){
      if (native.options[i].value !== '') texts.push(native.options[i].textContent.trim());
    }
    if (texts.length < 2) return '';
    var p = texts[0];
    for (var t = 1; t < texts.length; t++){
      var n = 0;
      while (n < p.length && n < texts[t].length && p[n] === texts[t][n]) n++;
      p = p.slice(0, n);
      if (!p) return '';
    }
    var cut = Math.max(p.lastIndexOf(' - '), p.lastIndexOf(' \u2013 '), p.lastIndexOf(': '));
    if (cut < 0) return '';
    var prefix = p.slice(0, cut + 3);
    // every choice has to have something left once it comes off
    for (var k = 0; k < texts.length; k++){
      if (texts[k].slice(prefix.length).trim() === '') return '';
    }
    return prefix;
  }

  function onlyChoice(native){
    var found = null;
    for (var i = 0; i < native.options.length; i++){
      if (native.options[i].value === '') continue;
      if (found) return null;
      found = native.options[i];
    }
    return found;
  }

  function optionName(native){
    var m = String(native.name || '').match(/^properties\[([\s\S]*)\]$/);
    return m ? m[1] : (native.name || native.id || '');
  }

  function place(){
    var fresh = box.querySelectorAll('select:not([data-hx-upgraded])');
    if (!fresh.length) return;

    // a fresh injection replaces whatever was placed last time, so the form
    // never ends up holding two selects under the same name
    var stale = document.querySelectorAll('[data-bundle-opt]');
    for (var s = 0; s < stale.length; s++) stale[s].remove();

    for (var i = 0; i < fresh.length; i++){
      var native = fresh[i];
      var name = optionName(native);
      var row = rowFor(native, name);

      var field = document.createElement('div');
      field.className = 'bundle-opt';
      field.dataset.bundleOpt = name;

      // the row's own heading names the product, so only a leftover needs a label
      if (!row){
        var lab = document.createElement('label');
        lab.textContent = fieldLabel(name);
        field.appendChild(lab);
      }

      var appLabel = native.previousElementSibling;
      if (appLabel && appLabel.tagName === 'LABEL') appLabel.remove();

      /* A required control the customer cannot see blocks the form with a
         browser message pointed at something invisible, so required comes off
         and the check moves to atcState() below, which can say what is wrong.
         The app leaves a select unpicked only when it has disabled every
         option — the component is sold out in every flavour — but if one is
         pickable and somehow none was picked, pick it, and tell the app, or
         its copy of the answer stays empty. */
      var pickable = null;
      for (var o = 0; o < native.options.length; o++){
        if (native.options[o].value !== '' && !native.options[o].disabled){ pickable = native.options[o]; break; }
      }
      if (!native.value && pickable){
        native.value = pickable.value;
        native.dispatchEvent(new Event('change', {bubbles: true}));
      }
      native.removeAttribute('required');
      native.hidden = true;
      field.appendChild(native);

      var only = onlyChoice(native);
      if (only && pickable){
        // one choice, already made: say what it is rather than offer a control
        // that opens onto the single line it is already showing
        var said = document.createElement('em');
        said.textContent = trimToRow(only.textContent.trim(), row && row.dataset.componentName);
        field.appendChild(said);
        native.dataset.hxUpgraded = '1';
      } else {
        window.HxFlavourSelect.upgrade(native, {
          mini: true,
          placeholder: pickable ? 'Choose a ' + fieldLabel(name).toLowerCase() : 'Sold out',
          stripPrefix: sharedPrefix(native),
          word: fieldLabel(name).toLowerCase(),
        });
      }
      // the row's View nutritional panel link, when it has one, stays under the choice
      var home = row ? row.querySelector('.it') || row : box;
      var opener = row ? home.querySelector('.np-open') : null;
      if (opener) home.insertBefore(field, opener); else home.appendChild(field);
    }

    /* Once the app has answered, a row with no dropdown is a row with nothing
       to choose — capsules, a fixed size — and saying so is better than a gap
       the customer reads as something that failed to load. Only after: with no
       answer yet, every row is still waiting. And only when every option found
       a row: with one still sitting in the container, a bare row might be the
       one it belongs to, and saying there is nothing to pick would be a lie
       with the dropdown visible right below it. */
    if (rows && !box.querySelector('.bundle-opt')) {
      var items = rows.querySelectorAll('.item');
      for (var r = 0; r < items.length; r++){
        if (items[r].querySelector('.bundle-opt') || items[r].querySelector('em')) continue;
        var none = document.createElement('em');
        none.dataset.bundleOpt = '';
        none.textContent = 'No flavour to pick';
        (items[r].querySelector('.it') || items[r]).appendChild(none);
      }
    }

    // whitespace and any label left behind would otherwise hold the box open
    if (!box.querySelector('select')) box.textContent = '';

    /* Three tubs of the same protein means three dropdowns in one row, and with
       nothing to tell them apart the customer cannot see which is which. The
       app numbers some of them itself ("Flavour 2") and not others ("Flavour
       (Select 2)", which reads as just "Flavour"), so only number what would
       otherwise come out identical. */
    if (rows){
      var items = rows.querySelectorAll('.item');
      for (var n = 0; n < items.length; n++){
        var fields = items[n].querySelectorAll('.bundle-opt');
        if (fields.length < 2) continue;
        var names = [], seen = {}, repeats = false;
        for (var f = 0; f < fields.length; f++){
          names[f] = fieldLabel(fields[f].dataset.bundleOpt);
          if (seen[names[f]]) repeats = true;
          seen[names[f]] = 1;
        }
        for (var g = 0; g < fields.length; g++){
          if (fields[g].querySelector('label')) continue;
          var tag = document.createElement('label');
          tag.textContent = repeats ? names[g] + ' ' + (g + 1) : names[g];
          fields[g].insertBefore(tag, fields[g].firstChild);
        }
      }
    }

    atcState();

    /* The rest of the page cannot wait for an app: hx-pdp.js has already run
       and found no dropdowns to clone into the get started block. */
    document.dispatchEvent(new CustomEvent('hx:bundle-options', {detail: {count: fresh.length}}));
  }

  /* A component with nothing pickable cannot be ordered, and the app's own
     answer for it stays empty, so the bundle would go into the cart short of a
     component. Today that shows up as a browser tooltip on a dropdown where
     everything is greyed out and no explanation; this says which component and
     stops there. Re-run on every change: a choice made is a component cleared. */
  function atcState(){
    var short = [];
    var fields = document.querySelectorAll('[data-bundle-opt]');
    for (var i = 0; i < fields.length; i++){
      var native = fields[i].querySelector('select');
      if (!native || native.value) continue;
      var row = fields[i].closest('.item');
      short.push(row ? row.dataset.componentName : fieldLabel(fields[i].dataset.bundleOpt));
    }

    var note = document.getElementById('hx-bundle-note');
    if (!note && rows){
      note = document.createElement('p');
      note.id = 'hx-bundle-note';
      note.className = 'bundle-note';
      rows.parentNode.insertBefore(note, rows.nextSibling);
    }
    if (note){
      note.textContent = short.length
        ? short.join(' and ') + (short.length > 1 ? ' are' : ' is') + ' sold out in every flavour, so this bundle cannot be ordered right now.'
        : '';
      note.hidden = !short.length;
    }

    var atc = document.getElementById('hxAtc');
    if (atc) atc.disabled = !!short.length;
  }

  document.addEventListener('change', function(e){
    if (e.target && e.target.closest && e.target.closest('[data-bundle-opt]')) atcState();
  });

  new MutationObserver(place).observe(box, {childList: true});
  place();
})();
